import React from 'react'
import "../../assets/scss/mygrid.scss";
import { useState, useEffect } from "react";
import { getTicker } from "../../services/TickerService";
import { isLargeScreen } from '../../utilities/ScreenView';
import { getMetadata } from "../../services/MetadataService";
import TickerHistorical from "./TickerHistorical";
import TickerIndicatorHistorical from "./TickerIndicatorHistorical";
import Trange from './Trange'
import GaugeChart from "./GaugeChart";

const Ticker = () => {

    const options = [
        { label: "AUDCAD", value: "AUDCAD", }, // 0
        { label: "AUDUSD", value: "AUDUSD", }, // 1
        { label: "BTCUSD", value: "BTCUSD", }, // 3
        { label: "DEUIDXEUR", value: "DEUIDXEUR" }, // 4
        { label: "EURAUD", value: "EURAUD", }, // 5
        { label: "EURGBP", value: "EURGBP", }, // 6
        { label: "EURUSD", value: "EURUSD", }, // 7
        { label: "GBPCHF", value: "GBPCHF", }, // 8
        { label: "GBPUSD", value: "GBPUSD", }, // 9
        { label: "HKGIDXHKD", value: "HKGIDXHKD", }, // 10
        { label: "NZDUSD", value: "NZDUSD", }, // 11
        { label: "USA30IDXUSD", value: "USA30IDXUSD", }, // 12
        { label: "USATECHIDXUSD", value: "USATECHIDXUSD", }, // 13
        { label: "USDCAD", value: "USDCAD", }, // 14
        { label: "USDJPY", value: "USDJPY", }, // 15
        { label: "XAGUSD", value: "XAGUSD"}, // 16
        { label: "XAUUSD", value: "XAUUSD", }, // 17
    ];

    const [instrument, setInstrument] = useState('');
    const [opendayprice, setOpendayprice] = useState('');
    const [closeprice, setCloseprice] = useState('');
    const [closetime, setClosetime] = useState('');
    const [tickpersec, setTickerpersec] = useState('');
    const [maxtickpersec, setMaxtickpersec] = useState('');

    useEffect(() => {
        const interval = setInterval(() => { isSelected(); getTickerData(); getTickerPerSecData(); }, 1000);
        return () => { clearInterval(interval); }
    });

    function handleChange(e) {
        setInstrument(e);
        getTickerData();
    }

    function getTickerData() {
        getTicker(instrument).then((response) => {
            setOpendayprice(response.data.openDayPrice);
            setCloseprice(response.data.closePrice);
            setClosetime(response.data.closeTime);
        }).catch(error => {
            console.log(error);
        })
    }

    function getTickerPerSecData() {
        getMetadata("TICK per SEC : " + instrument).then(response => {
            setTickerpersec(response.data.value);
        }).catch(error => {
            console.log(error);
        })

        getMetadata("MAX TICK per SEC : " + instrument).then(response => {
            setMaxtickpersec(response.data.value);
        }).catch(error => {
            console.log(error);
        })
    }

    function isNegative() {
        if (opendayprice === "" || closeprice === "") return "col border border-dark bg-muted text-white";
        if (opendayprice < closeprice) return "col border border-dark bg-success text-white";
        if (opendayprice === closeprice) return "col border border-dark bg-info text-white";
        return "col border border-dark bg-danger text-white";
    }

    function isSelected() {
        if (instrument === "") { setInstrument("AUDCAD"); }
        return true;
    }

    function showLabelWeb() {
        return (
            <>
                <div style={{ fontSize: 'small' }} className="col text-center bg-gradient"><span>Open Price</span></div>
                <div style={{ fontSize: 'small' }} className="col text-center bg-gradient"><span className="sp-ot">Ticks / Sec</span></div>
                <div style={{ fontSize: 'small' }} className="col text-center bg-gradient"><span>Last Price</span></div>
            </>
        )
    }

    function showLabelMobile() {
        return (
            <>
                <div style={{ fontSize: '9px' }} className="col text-center bg-gradient"><span>Open Price</span></div>
                <div className="col col-lg-3"><span /></div>
                <div style={{ fontSize: '9px' }} className="col text-center bg-gradient"><span>Current Price</span></div>
            </>
        )
    }

    function showPrice(type) {
        if ("AUDCAD AUDUSD EURAUD EURGBP EURUSD GBPUSD GBPCHF NZDUSD USDCAD".includes(instrument)) {
            if (type === 1) return String(opendayprice).substring(0, 4);
            if (type === 2) return String(closeprice).substring(0, 4);
            if (type === 3) return String(opendayprice).substring(4, 6);
            if (type === 4) return String(((closeprice - opendayprice) * 10000).toFixed(2));
            if (type === 5) return String(closeprice).substring(4, 6);
            if (type === 6) return String((opendayprice - closeprice).toFixed(5));
            if (type === 7) return String(((closeprice - opendayprice) / opendayprice * 100).toFixed(2)) + " % ";
        } else {
            if ("BRENTCMDUSD".includes(instrument)) {
                if (type === 1) return String(opendayprice).substring(0, 3);
                if (type === 2) return String(closeprice).substring(0, 3);
                if (type === 3) return String(opendayprice).substring(3, 5);
                if (type === 4) return String(((closeprice - opendayprice) * 10).toFixed(2));
                if (type === 5) return String(closeprice).substring(3, 5);
                if (type === 6) return String((opendayprice - closeprice).toFixed(5));
                if (type === 7) return String(((closeprice - opendayprice) / opendayprice * 100).toFixed(2)) + " % ";
            } else {
                if ("USA30IDXUSD USATECHIDXUSD DEUIDXEUR HKGIDXHKD BTCUSD".includes(instrument)) {
                    if (type === 1) return String(opendayprice).substring(0, 6);
                    if (type === 2) return String(closeprice).substring(0, 6);
                    if (type === 3) return String(opendayprice).substring(6, 8);
                    if (type === 4) return String(((closeprice - opendayprice) / 10).toFixed(2));
                    if (type === 5) return String(closeprice).substring(6, 8);
                    if (type === 6) return String((opendayprice - closeprice).toFixed(5));
                    if (type === 7) return String(((closeprice - opendayprice) / opendayprice * 100).toFixed(2)) + " % ";
                } else {
                    if ("USDJPY".includes(instrument)) {
                        if (type === 1) return String(opendayprice).substring(0, 4);
                        if (type === 2) return String(closeprice).substring(0, 4);
                        if (type === 3) return String(opendayprice).substring(4, 6);
                        if (type === 4) return String(((closeprice - opendayprice) / 10).toFixed(2));
                        if (type === 5) return String(closeprice).substring(4, 6);
                        if (type === 6) return String((opendayprice - closeprice).toFixed(5));
                        if (type === 7) return String(((closeprice - opendayprice) / opendayprice * 100).toFixed(2)) + " % ";
                    } else {
                        if ("XAGUSD XAUUSD".includes(instrument)) {
                            if (type === 1) return String(opendayprice).substring(0, 5);
                            if (type === 2) return String(closeprice).substring(0, 5);
                            if (type === 3) return String(opendayprice).substring(5, 7);
                            if (type === 4) return String(((closeprice - opendayprice) * 10).toFixed(2));
                            if (type === 5) return String(closeprice).substring(5, 7);
                            if (type === 6) return String((opendayprice - closeprice).toFixed(5));
                            if (type === 7) return String(((closeprice - opendayprice) / opendayprice * 100).toFixed(2)) + " % ";
                        }
                    }
                }
            }
        }
    }

    function showTicker() {
        return (
            <>
                { isLargeScreen() ? showTickerWeb() : showTickerMobile() }
            </>
        )
    }

function showTickerWeb() {
        return (
            <>
                <div style={{paddingLeft: '40px'}}>
                    <span className="sp-ot">Online Bid Ticker<br /></span>
                    <select
                        id="tickerOptions"
                        className="selectpicker sl-tr dropdown-toggle"
                        value={instrument}
                        onChange={(e) => handleChange(e.target.value)}
                        defaultValue={{ label: "AUDCAD", value: "AUDCAD" }}
                    >
                        {options.map((option) => (
                            <option value={option.value}>{option.label}</option>
                        ))}
                    </select>
                    <div className="row pt-4">
                        <div className="col border border-dark bg-info text-white fs-4 rounded-3 bg-gradient"><span>{showPrice(1)}</span></div>
                        <div className="col col-lg-3"><span /></div>
                        <div className={isNegative() + " text-left fs-4 rounded-3 bg-gradient"}><span>{showPrice(2)}</span></div>
                    </div>
                    <div className="row pt-1">
                        <div className="col border border-dark bg-info text-white text-center fs-4 rounded-3 bg-gradient"><span>{showPrice(3)}</span></div>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} className="col col-lg-3 text-white text-center fs-6 bg-gradient"><span className="border border-dark bg-warning rounded-3 bg-gradient">&nbsp;{showPrice(4)}&nbsp;</span></div>
                        <div className={isNegative() + " text-center fs-4 rounded-3 bg-gradient"}><span>{showPrice(5)}</span></div>
                    </div>
                    <div className="row pt-1">
                        <div className="col border border-dark bg-info text-white text-center fs-6 rounded-3 bg-gradient"><span>{showPrice(6)}</span></div>
                        <div className="col col-lg-3"><span /></div>
                        <div className={isNegative() + " text-center fs-6 rounded-3 bg-gradient"}><span>{showPrice(7)}</span></div>
                    </div>
                    <div className="row pt-1">
                        { showLabelWeb() }
                    </div>
                    <div className="row pt-1">
                        <div className="col border border-dark bg-info text-white text-center fs-6 rounded-3 bg-gradient">
                            <span>{new Date(closetime).toLocaleString("en-GB", { month: "2-digit", day: "2-digit", year: "numeric", })}</span>
                        </div>
                        <div className="col text-center fs-6">
                            <span className="border border-dark bg-warning rounded-3 bg-gradient text-center">&nbsp;&nbsp;{ tickpersec }&nbsp;:&nbsp;{ maxtickpersec }&nbsp;&nbsp;</span>
                        </div>
                        <div className={isNegative() + " text-center fs-6 rounded-3 bg-gradient"}>
                            <span>{new Date(closetime).toLocaleString("en-GB", { hour: "2-digit", minute: "2-digit", second: "2-digit", })}</span>
                        </div>
                        <TickerHistorical param={instrument}/>
                    </div>
                    <div>
                        <TickerIndicatorHistorical param={instrument}/>
                        <GaugeChart param={instrument}/>
                    </div>
                </div>
            </>
        )
    }

function showTickerMobile() {
        return (
            <>
                <div style={{paddingLeft: '0px'}}>
                    <span className="sp-ot">Online Bid Ticker<br /></span>
                    <select
                        id="tickerOptions"
                        className="selectpicker sl-tr dropdown-toggle"
                        value={instrument}
                        onChange={(e) => handleChange(e.target.value)}
                        defaultValue={{ label: "AUDCAD", value: "AUDCAD" }}
                    >
                        {options.map((option) => (
                            <option value={option.value}>{option.label}</option>
                        ))}
                    </select>
                    <div className="row pt-4">
                        <div className="col border border-dark bg-info text-white fs-4 rounded-3 bg-gradient"><span>{showPrice(1)}</span></div>
                        <div className="col col-lg-3"><span /></div>
                        <div className={isNegative() + " text-left fs-4 rounded-3 bg-gradient"}><span>{showPrice(2)}</span></div>
                    </div>
                    <div className="row pt-1">
                        <div className="col border border-dark bg-info text-white text-center fs-4 rounded-3 bg-gradient"><span>{showPrice(3)}</span></div>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} className="col col-lg-3 text-white text-center fs-6 bg-gradient"><span className="border border-dark bg-warning rounded-3 bg-gradient">&nbsp;{showPrice(4)}&nbsp;</span></div>
                        <div className={isNegative() + " text-center fs-4 rounded-3 bg-gradient"}><span>{showPrice(5)}</span></div>
                    </div>
                    <div className="row pt-1">
                        <div className="col border border-dark bg-info text-white text-center fs-6 rounded-3 bg-gradient"><span>{showPrice(6)}</span></div>
                        <div className="col col-lg-3"><span /></div>
                        <div className={isNegative() + " text-center fs-6 rounded-3 bg-gradient"}><span>{showPrice(7)}</span></div>
                    </div>
                    <div className="row pt-1">
                        { showLabelMobile() }
                    </div>
                    <div className="row pt-1">
                        <div className="col border border-dark bg-info text-white text-center fs-6 rounded-3 bg-gradient">
                            <span>{new Date(closetime).toLocaleString("en-GB", { month: "2-digit", day: "2-digit", year: "numeric", })}</span>
                        </div>
                        <div className="col col-lg-3"><span /></div>
                        <div className={isNegative() + " text-center fs-6 rounded-3 bg-gradient"}>
                            <span>{new Date(closetime).toLocaleString("en-GB", { hour: "2-digit", minute: "2-digit", second: "2-digit", })}</span>
                        </div>
                    </div>
                </div>
                <TickerHistorical param={instrument}/>
                <Trange />
            </>
        )
    }        

    function showSpinner() {
        return (
            <>
                <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </>
        )
    }

    return (
        <>
            <div style={{ paddingLeft: '40px', paddingRight: '20px' }} className="col-sm-4">
                { opendayprice === "" ?  showSpinner() : showTicker()}
            </div>
        </>
    )
}

export default Ticker